<template>
  <div class="home subs">
    <div class="columns">
      <div class="column">
        <h2>סטטיסטיקות העדפות מנויים</h2>
      </div>

      <div class="column has-text-left">
        <router-link :to="{ name: 'home' }" class="nav-btn button"
          >חזור לניהול מנויים</router-link
        >
      </div>
    </div>
    <div class="table-scroll" v-if="!$store.state.stats.loading">
      <div class="box has-background-light">
        <div class="columns">
          <div class="column">
            <div class="field">
              <label class="label">התחלה</label>
              <div class="control">
                <datepicker
                  v-model="fields.start_date"
                  placeholder="מתאריך"
                  :language="he"
                  input-class="input"
                  :disabledDates="{ from: new Date() }"
                ></datepicker>
              </div>
            </div>
          </div>

          <div class="column">
            <div class="field">
              <label class="label">עד תאריך</label>
              <div class="control">
                <datepicker
                  v-model="fields.end_date"
                  placeholder="עד תאריך"
                  :language="he"
                  input-class="input"
                  :disabledDates="{ from: new Date() }"
                ></datepicker>
              </div>
            </div>
          </div>
          <div class="column">
            <button class="button" @click="setSubs" style="margin-top:2em;">
              הצג
            </button>
          </div>
        </div>
      </div>

      <div class="chart-container">
        <a @click.prevent="openDetails">
          <line-chart
            :chartData="subsData"
            :options="xpOptions"
            v-if="subsData"
          ></line-chart>
        </a>
        <div class="box has-background-grey-lighter stat-box">
          <div class="columns is-multiline">
            <div class="column has-background-light">
              <h3>{{ selectedDuration }}</h3>
              <p><strong>הצטרפו:</strong> {{ joined.length }}</p>
              <p><strong>עזבו:</strong> {{ canceledAccounts.length }}</p>
              <p><strong>חידשו:</strong> {{ renewed.length }}</p>
            </div>
            <div class="column">
              <h3>היום</h3>
              <p><strong>הצטרפו:</strong> {{ today.joined.length }}</p>
              <p><strong>עזבו:</strong> {{ today.canceled.length }}</p>
              <p><strong>חידשו:</strong> {{ today.renewed.length }}</p>
              <p>
                <strong>נטו:</strong>
                {{
                  today.joined.length -
                    today.canceled.length +
                    today.renewed.length
                }}
              </p>
            </div>
            <div class="column">
              <h3>7 הימים האחרונים</h3>
              <p><strong>הצטרפו:</strong> {{ last7days.joined.length }}</p>
              <p><strong>עזבו:</strong> {{ last7days.canceled.length }}</p>
              <p><strong>חידשו:</strong> {{ last7days.renewed.length }}</p>
              <p>
                <strong>נטו:</strong>
                {{
                  last7days.joined.length -
                    last7days.canceled.length +
                    last7days.renewed.length
                }}
              </p>
            </div>
            <div class="column">
              <h3>30 הימים האחרונים</h3>
              <p><strong>הצטרפו:</strong> {{ last30days.joined.length }}</p>
              <p><strong>עזבו:</strong> {{ last30days.canceled.length }}</p>
              <p><strong>חידשו:</strong> {{ last30days.renewed.length }}</p>
              <p>
                <strong>נטו:</strong>
                {{
                  last30days.joined.length -
                    last30days.canceled.length +
                    last30days.renewed.length
                }}
              </p>
            </div>
            <div class="column">
              <h3>360 הימים האחרונים</h3>
              <p><strong>הצטרפו:</strong> {{ last360days.joined.length }}</p>
              <p><strong>עזבו:</strong> {{ last360days.canceled.length }}</p>
              <p><strong>חידשו:</strong> {{ last360days.renewed.length }}</p>
              <p>
                <strong>נטו:</strong>
                {{
                  last360days.joined.length -
                    last360days.canceled.length +
                    last360days.renewed.length
                }}
              </p>
            </div>
            <div class="column">
              <h3>משך זמן מנוי ממוצע</h3>
              <p>
                {{ averageDuration }}
              </p>
            </div>
          </div>
        </div>
      </div>

      <div class="chart-container">
        <bar-chart
          :chartData="xpTotal"
          :options="xpOptions"
          v-if="$store.state.stats.xp"
        ></bar-chart>
      </div>

      <div class="chart-container">
        <bar-chart
          :chartData="interestsTotal"
          :options="xpOptions"
          v-if="$store.state.stats.interest"
        ></bar-chart>
      </div>

      <div class="chart-container">
        <bar-chart
          :chartData="styleTotal"
          :options="xpOptions"
          v-if="$store.state.stats.style"
        ></bar-chart>
      </div>
      <div :class="modalClass">
        <div class="modal-background"></div>
        <div class="modal-content">
          <!-- Any other Bulma elements you want -->
          <div class="box">
            <nav class="panel">
              <p class="panel-heading has-text-centered">
                {{ modalHeader }}
              </p>
              <!-- <div class="panel-block">
                <p class="control has-icons-left">
                  <input class="input" type="text" placeholder="Search" />
                  <span class="icon is-left">
                    <i class="fas fa-search" aria-hidden="true"></i>
                  </span>
                </p>
              </div> -->
              <p class="panel-tabs">
                <a :class="tabClass(1)" @click="modalShow = 1">הצטרפו</a>
                <a :class="tabClass(2)" @click="modalShow = 2">עזבו</a>
                <a :class="tabClass(3)" @click="modalShow = 3">חידשו</a>
              </p>
              <div v-if="modalShow === 1">
                <a
                  class="panel-block"
                  v-for="sub in joined"
                  :key="sub.id"
                  @click="isShowingDetails = sub.id"
                >
                  <div :class="showdetails(sub.id)">
                    <small> ({{ sub.id }}) </small>
                    {{ sub.fullname }}
                    <div>
                      <hr />
                      <strong>אימייל:</strong>{{ sub.email }}
                      <hr />
                      <p>
                        <strong>תאריך הרשמה:</strong
                        >{{ formatDate(sub.sub_date) }}
                      </p>
                      <hr />
                      <p>
                        <strong>משך זמן המנוי:</strong>
                        {{ getSubDuration(sub) }} ימים
                      </p>
                      <hr />
                      <p v-if="sub.cupon">
                        <strong>השתמש בקופון</strong> {{ sub.cupon.cupon }}
                      </p>
                    </div>
                  </div>
                </a>
              </div>
              <div v-if="modalShow === 2">
                <a
                  class="panel-block"
                  v-for="sub in canceledAccounts"
                  :key="sub.id"
                  @click="isShowingDetails = sub.id"
                >
                  <div :class="showdetails(sub.id)">
                    <span> ({{ sub.id }}) </span>
                    {{ sub.fullname }}
                    <div>
                      <hr />
                      <strong>אימייל:</strong>{{ sub.email }}
                      <hr />
                      <p>
                        <strong>תאריך הרשמה:</strong
                        >{{ formatDate(sub.sub_date) }}
                      </p>
                      <hr />
                      <p>
                        <strong>תאריך ביטול:</strong
                        >{{ formatDate(sub.cancel_date) }}
                      </p>
                      <hr />
                      <p>
                        <strong>סוג ביטול:</strong>
                        {{ cancelType(sub.cancel_type) }}
                      </p>
                      <p>
                        <strong>סיבת ביטול:</strong>
                        {{ cancelReason(sub.cancel_reason) }}
                      </p>
                      <hr />
                      <p>
                        <strong>משך זמן המנוי:</strong>
                        {{ getSubDuration(sub) }} ימים
                      </p>
                      <hr />
                      <p v-if="sub.cupon">
                        <strong>השתמש בקופון</strong> {{ sub.cupon.cupon }}
                      </p>
                    </div>
                  </div>
                </a>
              </div>
              <div v-if="modalShow === 3">
                <a
                  class="panel-block"
                  v-for="sub in renewed"
                  :key="sub.id"
                  @click="isShowingDetails = sub.id"
                >
                  <div :class="showdetails(sub.id)">
                    <span> ({{ sub.id }}) </span>
                    {{ sub.fullname }}
                    <div>
                      <hr />
                      <strong>אימייל:</strong>{{ sub.email }}
                      <hr />
                      <p>
                        <strong>תאריך הרשמה:</strong
                        >{{ formatDate(sub.sub_date) }}
                      </p>
                      <hr />
                      <p>
                        <strong>תאריך ביטול:</strong
                        >{{ formatDate(sub.cancel_date) }}
                      </p>
                      <hr />
                      <p>
                        <strong>סוג ביטול:</strong>
                        {{ cancelType(sub.cancel_type) }}
                      </p>
                      <p>
                        <strong>סיבת ביטול:</strong>
                        {{ cancelReason(sub.cancel_reason) }}
                      </p>
                      <hr />
                      <p>
                        <strong>משך זמן המנוי:</strong>
                        {{ getSubDuration(sub) }} ימים
                      </p>
                      <hr />
                      <p v-if="sub.cupon">
                        <strong>השתמש בקופון</strong> {{ sub.cupon.cupon }}
                      </p>
                    </div>
                  </div>
                </a>
              </div>
            </nav>
          </div>
        </div>
        <button
          class="modal-close is-large"
          aria-label="close"
          @click="modalopen = false"
        ></button>
      </div>
    </div>
    <div v-else class="stats-loading has-background-light has-text-info">
      טוען נתונים
    </div>
  </div>
</template>

<script>
import BarChart from "@/components/stats/BarChart.vue";
import LineChart from "@/components/stats/lineChart.vue";
import Datepicker from "vuejs-datepicker";
import { he } from "vuejs-datepicker/dist/locale";
import formatISO from "date-fns/formatISO";
import parseISO from "date-fns/parseISO";
import isAfter from "date-fns/isAfter";
import isEqual from "date-fns/isEqual";
import subDays from "date-fns/subDays";
import { he as heb, ca } from "date-fns/locale";
import { format } from "date-fns";
import set from "date-fns/set";
import eachDayOfInterval from "date-fns/eachDayOfInterval";
import isToday from "date-fns/isToday";
import toDate from "date-fns/toDate";

export default {
  components: {
    BarChart,
    LineChart,
    Datepicker
  },
  data() {
    return {
      xpOptions: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true
              }
            }
          ]
        }
      },
      fields: {
        end_date: new Date(),
        start_date: subDays(new Date(), 7)
      },
      he: he,
      disabledDates: {
        to: new Date()
      },
      subsData: null,
      joined: [],
      canceledAccounts: [],
      renewed: [],
      modalopen: false,
      modalShow: 1,
      showJoined: true,
      isShowingDetails: 0,
      today: {
        joined: [],
        canceled: [],
        renewed: []
      },
      last7days: {
        joined: [],
        canceled: [],
        renewed: []
      },
      last30days: {
        joined: [],
        canceled: [],
        renewed: []
      },
      last360days: {
        joined: [],
        canceled: [],
        renewed: []
      },
      subDurations: []
    };
  },
  watch: {
    xpTotal() {
      this.setSubs();
    }
  },

  computed: {
    averageDuration() {
      const average =
        this.subDurations.reduce((a, b) => a + b, 0) / this.subDurations.length;
      if (Number.isNaN(average)) {
        return "***";
      }
      return `${parseInt(average, 10)} ימים`;
    },
    selectedDuration() {
      return `${format(
        parseISO(formatISO(this.fields.start_date)),
        "dd-MM-yyyy",
        { locale: heb }
      )} - ${format(parseISO(formatISO(this.fields.end_date)), "dd-MM-yyyy", {
        locale: heb
      })}`;
    },
    modalHeader() {
      if (this.modalShow === 1) {
        return `מצטרפים בתאריכים ${this.selectedDuration}`;
      }
      if (this.modalShow === 2) {
        return `עזבו בתאריכים ${this.selectedDuration}`;
      }
      return `חידשו בתאריכים ${this.selectedDuration}`;
    },
    xpTotal() {
      const total = [0, 0, 0, 0];
      if (Array.isArray(this.$store.state.stats.xp)) {
        this.$store.state.stats.xp.forEach(item => {
          if (item !== null) {
            const spread = item.split(",");
            spread.forEach((val, index) => {
              if (val === "true") {
                total[index]++;
              }
            });
          }
        });
      }

      const chartData = {
        datasets: [
          {
            label: "מתי התחלת לתרגל?",
            data: total,
            backgroundColor: [
              "rgba(255, 99, 132, 0.2)",
              "rgba(54, 162, 235, 0.2)",
              "rgba(255, 206, 86, 0.2)",
              "rgba(75, 192, 192, 0.2)",
              "rgba(153, 102, 255, 0.2)",
              "rgba(255, 159, 64, 0.2)"
            ],
            borderColor: [
              "rgba(255,99,132,1)",
              "rgba(54, 162, 235, 1)",
              "rgba(255, 206, 86, 1)",
              "rgba(75, 192, 192, 1)",
              "rgba(153, 102, 255, 1)",
              "rgba(255, 159, 64, 1)"
            ],
            borderWidth: 1
          }
        ],
        labels: [
          "אני מתחילה - אין לי רקע",
          "אני מתרגלת כבר למעלה משנה",
          "הייתי במספר שיעורים בעבר",
          "אני מורה ליוגה או פילאטיס"
        ]
      };
      return chartData;
    },

    interestsTotal() {
      const total = [0, 0, 0, 0, 0];
      if (Array.isArray(this.$store.state.stats.interest)) {
        this.$store.state.stats.interest.forEach(item => {
          if (item !== null) {
            const spread = item.split(",");
            spread.forEach((val, index) => {
              if (val === "true") {
                total[index]++;
              }
            });
          }
        });
      }

      const chartData = {
        datasets: [
          {
            label: "במה אתה מתענייןת",
            data: total,
            backgroundColor: [
              "rgba(255, 99, 132, 0.2)",
              "rgba(54, 162, 235, 0.2)",
              "rgba(255, 206, 86, 0.2)",
              "rgba(75, 192, 192, 0.2)",
              "rgba(153, 102, 255, 0.2)",
              "rgba(255, 159, 64, 0.2)"
            ],
            borderColor: [
              "rgba(255,99,132,1)",
              "rgba(54, 162, 235, 1)",
              "rgba(255, 206, 86, 1)",
              "rgba(75, 192, 192, 1)",
              "rgba(153, 102, 255, 1)",
              "rgba(255, 159, 64, 1)"
            ],
            borderWidth: 1
          }
        ],
        labels: ["חיזוק", "שלווה", "התמודדות עם כאב", "פשוט לזוז", "ללמוד יותר"]
      };
      return chartData;
    },

    styleTotal() {
      const total = [0, 0, 0, 0, 0];
      if (Array.isArray(this.$store.state.stats.style)) {
        this.$store.state.stats.style.forEach(item => {
          if (item !== null) {
            const spread = item.split(",");
            spread.forEach((val, index) => {
              if (val === "true") {
                if (index < 4) {
                  total[index]++;
                }
              }
            });
          } else {
            total[4]++;
          }
        });
      }

      const chartData = {
        datasets: [
          {
            label: "יש לך סגנון מועדף?",
            data: total,
            backgroundColor: [
              "rgba(255, 99, 132, 0.2)",
              "rgba(54, 162, 235, 0.2)",
              "rgba(255, 206, 86, 0.2)",
              "rgba(75, 192, 192, 0.2)",
              "rgba(153, 102, 255, 0.2)",
              "rgba(255, 159, 64, 0.2)"
            ],
            borderColor: [
              "rgba(255,99,132,1)",
              "rgba(54, 162, 235, 1)",
              "rgba(255, 206, 86, 1)",
              "rgba(75, 192, 192, 1)",
              "rgba(153, 102, 255, 1)",
              "rgba(255, 159, 64, 1)"
            ],
            borderWidth: 1
          }
        ],
        labels: ["יוגה", "מדיטציה", "פילאטיס", "שיעורי הריון ולאחר לידה"]
      };
      return chartData;
    },
    modalClass() {
      if (this.modalopen) {
        return "modal is-active";
      }
      return "modal";
    }

    // startDate() {
    //   return Date.parse(this.fields.start_date);
    // }
  },
  methods: {
    setSubs() {
      let canceled = [];
      let renewed = [];
      let newSubs = [];
      let canceledata = [];
      let joineddata = [];
      let reneweddata = [];
      let chartLabels = [];

      this.today = {
        joined: [],
        canceled: [],
        renewed: []
      };

      this.last7days = {
        joined: [],
        canceled: [],
        renewed: []
      };

      this.last30days = {
        joined: [],
        canceled: [],
        renewed: []
      };

      this.last360days = {
        joined: [],
        canceled: [],
        renewed: []
      };

      let end = set(parseISO(formatISO(this.fields.end_date)), {
        hours: 23,
        minutes: 59,
        seconds: 59,
        milliseconds: 0
      });

      let start = set(parseISO(formatISO(this.fields.start_date)), {
        hours: 0,
        minutes: 0,
        seconds: 0,
        milliseconds: 0
      });

      chartLabels = eachDayOfInterval({ start: start, end: end });
      let chartLabelsFormatted = chartLabels.map(item =>
        format(item, "dd-MM-yyyy", { locale: heb })
      );

      chartLabels.forEach(label => {
        joineddata.push([]);
        canceledata.push([]);
        reneweddata.push([]);
      });

      this.$store.state.stats.subs.forEach(sub => {
        if (sub.sub_date !== null) {
          let sub_date = set(parseISO(sub.sub_date), {
            hours: 12,
            minutes: 0,
            seconds: 0,
            milliseconds: 0
          });

          if (sub.cancel_date !== null && sub.cancel_date.length > 0) {
            let cancel = set(parseISO(sub.cancel_date), {
              hours: 12,
              minutes: 0,
              seconds: 0,
              milliseconds: 0
            });

            if (
              (isAfter(end, cancel) || isEqual(end, cancel)) &&
              (isAfter(cancel, start) || isEqual(cancel, start))
            ) {
              canceled.push(sub);
              let date = format(cancel, "dd-MM-yyyy", { locale: heb });
              let index = chartLabelsFormatted.indexOf(date);
              if (index > -1) {
                canceledata[index].push(sub);
              }
            }
            this.subDuration(sub_date, cancel);
          } else {
            // push active sub duration
            if (sub.status === "1") {
              this.subDuration(sub_date, false);
            }
          }

          if (
            (isAfter(sub_date, start) || isEqual(sub_date, start)) &&
            (isAfter(end, sub_date) || isEqual(end, sub_date))
          ) {
            newSubs.push(sub);
            let date = format(sub_date, "dd-MM-yyyy", { locale: heb });
            let index = chartLabelsFormatted.indexOf(date);
            if (index > -1) {
              joineddata[index].push(sub);
            }
          }

          if (sub.renew_date !== null && sub.renew_date.length > 0) {
            let renew_date = set(parseISO(sub.renew_date), {
              hours: 12,
              minutes: 0,
              seconds: 0,
              milliseconds: 0
            });

            if (
              (isAfter(renew_date, start) || isEqual(renew_date, start)) &&
              (isAfter(end, renew_date) || isEqual(end, renew_date))
            ) {
              renewed.push(sub);
              let date = format(renew_date, "dd-MM-yyyy", { locale: heb });
              let index = chartLabelsFormatted.indexOf(date);
              if (index > -1) {
                reneweddata[index].push(sub);
              }
            }
          }
        }
        this.todayStats(sub);
        this.last7daysStats(sub);
        this.last30daysStats(sub);
        this.last360daysStats(sub);
      });

      let neto = [];

      joineddata.forEach((item, index) => {
        neto.push(
          item.length - canceledata[index].length + reneweddata[index].length
        );
      });

      const chartData = {
        datasets: [
          {
            label: "הצטרפו",
            data: joineddata.map(item => item.length),
            backgroundColor: "rgba(54, 162, 235, 0.2)",
            borderColor: "rgba(54, 162, 235, 1)",
            borderWidth: 1,
            fill: false
          },
          {
            label: "עזבו",
            data: canceledata.map(item => item.length),
            backgroundColor: "rgba(255, 99, 132, 0.2)",
            borderColor: "rgba(255, 99, 132, 1)",
            borderWidth: 1,
            fill: false
          },
          {
            label: "נטו",
            data: neto,
            borderColor: "rgba(255, 159, 64, 1)",
            backgroundColor: "rgba(255, 159, 64, 0.2)",
            borderWidth: 1,
            fill: false
          },
          {
            label: "חידשו",
            data: reneweddata.map(item => item.length),
            borderColor: "rgba(153, 102, 255, 1)",
            backgroundColor: "rgba(153, 102, 255, 0.2)",
            borderWidth: 1,
            fill: false
          }
        ],
        labels: chartLabelsFormatted
      };
      this.subsData = chartData;
      this.joined = newSubs;
      this.canceledAccounts = canceled;
      this.renewed = renewed;
    },
    openDetails() {
      this.modalopen = true;
    },
    showdetails(id) {
      if (this.isShowingDetails === id) {
        return "sub-details open";
      } else {
        return "sub-details closed";
      }
    },
    formatDate(date) {
      if (date) {
        return format(parseISO(date), "dd-MM-yyyy", { locale: heb });
      }
      return "לא ידוע";
    },
    cancelType(type) {
      let output = "לא ידוע";
      if (type === "payment problem") {
        output = "בעיה בתשלום";
      }

      if (type === "User Cancel") {
        output = "משתמש ביטל";
      }
      return output;
    },
    cancelReason(reason) {
      if (reason) {
        return reason;
      }
      return "***";
    },
    todayStats(sub) {
      if (sub.sub_date !== null) {
        let sub_date = set(parseISO(sub.sub_date), {
          hours: 12,
          minutes: 0,
          seconds: 0,
          milliseconds: 0
        });

        if (sub.cancel_date !== null && sub.cancel_date.length > 0) {
          let cancel = set(parseISO(sub.cancel_date), {
            hours: 12,
            minutes: 0,
            seconds: 0,
            milliseconds: 0
          });

          if (isToday(cancel)) {
            this.today.canceled.push(sub);
          }
        }
        if (sub.renew_date !== null && sub.renew_date.length > 0) {
          let renew_date = set(parseISO(sub.renew_date), {
            hours: 12,
            minutes: 0,
            seconds: 0,
            milliseconds: 0
          });

          if (isToday(renew_date)) {
            this.today.renewed.push(sub);
          }
        }

        if (isToday(sub_date)) {
          this.today.joined.push(sub);
        }
      }
    },
    last7daysStats(sub) {
      if (sub.sub_date !== null) {
        let sub_date = set(parseISO(sub.sub_date), {
          hours: 12,
          minutes: 0,
          seconds: 0,
          milliseconds: 0
        });

        let start = set(subDays(toDate(new Date()), 7), {
          hours: 12,
          minutes: 0,
          seconds: 0,
          milliseconds: 0
        });
        let end = set(toDate(new Date()), {
          hours: 12,
          minutes: 0,
          seconds: 0,
          milliseconds: 0
        });

        if (sub.cancel_date !== null && sub.cancel_date.length > 0) {
          let cancel = set(parseISO(sub.cancel_date), {
            hours: 12,
            minutes: 0,
            seconds: 0,
            milliseconds: 0
          });

          if (
            (isAfter(end, cancel) || isEqual(end, cancel)) &&
            (isAfter(cancel, start) || isEqual(cancel, start))
          ) {
            this.last7days.canceled.push(sub);
          }
        }

        if (sub.renew_date !== null && sub.renew_date.length > 0) {
          let renew_date = set(parseISO(sub.renew_date), {
            hours: 12,
            minutes: 0,
            seconds: 0,
            milliseconds: 0
          });

          if (
            (isAfter(renew_date, start) || isEqual(renew_date, start)) &&
            (isAfter(end, renew_date) || isEqual(end, renew_date))
          ) {
            this.last7days.renewed.push(sub);
          }
        }

        if (
          (isAfter(sub_date, start) || isEqual(sub_date, start)) &&
          (isAfter(end, sub_date) || isEqual(end, sub_date))
        ) {
          this.last7days.joined.push(sub);
        }
      }
    },
    last30daysStats(sub) {
      if (sub.sub_date !== null) {
        let sub_date = set(parseISO(sub.sub_date), {
          hours: 12,
          minutes: 0,
          seconds: 0,
          milliseconds: 0
        });

        let start = set(subDays(toDate(new Date()), 30), {
          hours: 12,
          minutes: 0,
          seconds: 0,
          milliseconds: 0
        });
        let end = set(toDate(new Date()), {
          hours: 12,
          minutes: 0,
          seconds: 0,
          milliseconds: 0
        });

        if (sub.cancel_date !== null && sub.cancel_date.length > 0) {
          let cancel = set(parseISO(sub.cancel_date), {
            hours: 12,
            minutes: 0,
            seconds: 0,
            milliseconds: 0
          });

          if (
            (isAfter(end, cancel) || isEqual(end, cancel)) &&
            (isAfter(cancel, start) || isEqual(cancel, start))
          ) {
            this.last30days.canceled.push(sub);
          }
        }

        if (sub.renew_date !== null && sub.renew_date.length > 0) {
          let renew_date = set(parseISO(sub.renew_date), {
            hours: 12,
            minutes: 0,
            seconds: 0,
            milliseconds: 0
          });

          if (
            (isAfter(renew_date, start) || isEqual(renew_date, start)) &&
            (isAfter(end, renew_date) || isEqual(end, renew_date))
          ) {
            this.last30days.renewed.push(sub);
          }
        }

        if (
          (isAfter(sub_date, start) || isEqual(sub_date, start)) &&
          (isAfter(end, sub_date) || isEqual(end, sub_date))
        ) {
          this.last30days.joined.push(sub);
        }
      }
    },
    last360daysStats(sub) {
      if (sub.sub_date !== null) {
        let sub_date = set(parseISO(sub.sub_date), {
          hours: 12,
          minutes: 0,
          seconds: 0,
          milliseconds: 0
        });

        let start = set(subDays(toDate(new Date()), 360), {
          hours: 12,
          minutes: 0,
          seconds: 0,
          milliseconds: 0
        });
        let end = set(toDate(new Date()), {
          hours: 12,
          minutes: 0,
          seconds: 0,
          milliseconds: 0
        });

        if (sub.cancel_date !== null && sub.cancel_date.length > 0) {
          let cancel = set(parseISO(sub.cancel_date), {
            hours: 12,
            minutes: 0,
            seconds: 0,
            milliseconds: 0
          });

          if (
            (isAfter(end, cancel) || isEqual(end, cancel)) &&
            (isAfter(cancel, start) || isEqual(cancel, start))
          ) {
            this.last360days.canceled.push(sub);
          }
        }

        if (sub.renew_date !== null && sub.renew_date.length > 0) {
          let renew_date = set(parseISO(sub.renew_date), {
            hours: 12,
            minutes: 0,
            seconds: 0,
            milliseconds: 0
          });

          if (
            (isAfter(renew_date, start) || isEqual(renew_date, start)) &&
            (isAfter(end, renew_date) || isEqual(end, renew_date))
          ) {
            this.last360days.renewed.push(sub);
          }
        }

        if (
          (isAfter(sub_date, start) || isEqual(sub_date, start)) &&
          (isAfter(end, sub_date) || isEqual(end, sub_date))
        ) {
          this.last360days.joined.push(sub);
        }
      }
    },
    subDuration(sub_date, cancel_date) {
      // console.log(`start - ${sub_date} end - ${cancel_date}`);
      let end = cancel_date;
      if (!cancel_date) {
        end = set(toDate(new Date()), {
          hours: 12,
          minutes: 0,
          seconds: 0,
          milliseconds: 0
        });
      }
      if (isAfter(end, sub_date)) {
        let days = eachDayOfInterval({ start: sub_date, end: end });
        this.subDurations.push(days.length);
      }
    },
    getSubDuration(sub) {
      let end = set(parseISO(sub.cancel_date), {
        hours: 12,
        minutes: 0,
        seconds: 0,
        milliseconds: 0
      });
      let start = set(parseISO(sub.sub_date), {
        hours: 12,
        minutes: 0,
        seconds: 0,
        milliseconds: 0
      });
      if (!sub.cancel_date) {
        end = set(toDate(new Date()), {
          hours: 12,
          minutes: 0,
          seconds: 0,
          milliseconds: 0
        });
      }
      if (isAfter(end, start)) {
        let days = eachDayOfInterval({ start: start, end: end });
        return days.length;
      }
      return 0;
    },
    tabClass(num) {
      if (this.modalShow === num) {
        return "is-active";
      }
      return "";
    }
  },

  mounted() {
    this.$store.dispatch("fetchStats");
    this.setSubs();
  }
};
</script>

<style lang="scss">
.chart-container {
  position: relative;
  margin-bottom: 30px;
}

.panel-block {
  .closed {
    div {
      height: 0;
      overflow: hidden;
    }
  }
  .open {
    background-color: hsl(0, 0%, 86%);
    div {
      height: auto;
    }
  }
  .sub-details {
    width: 100%;
    hr {
      background-color: hsl(204, 86%, 53%);
      margin: 5px auto;
      height: 1px;
    }
    strong {
      margin-left: 5px;
    }
  }
}
.stat-box {
  margin: 1rem auto;
  max-width: 95%;
  h3 {
    font-size: 1.2rem;
  }
  p {
    font-size: 0.9rem;
  }
}
.stats-loading {
  height: 75vh;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 3rem;
}
</style>
